<template>
    <div class="modal modal-open" id="modal-add-new-service">
        <div class="modal-overflow">
            <div class="modal-window">
                <button class="btn btn-modal-close" @click="handleClose">
                    <i class="icon icon-cancel"></i>
                </button>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-xl-12 col-lg-12">
                            <div class="form-field form-field--text">
                                <label for="name"
                                    >Service
                                    <span style="color: red">*</span></label
                                >
                                <input
                                    type="text"
                                    v-model="data.name_of_service"
                                    id="service"
                                />
                                <span
                                    class="error"
                                    v-if="errors.name_of_service"
                                    >{{ errors.name_of_service }}</span
                                >
                            </div>
                        </div>
                        <div class="col-xl-12 col-lg-12">
                            <div class="form-field form-field--tree">
                                <label for="name">Parent service </label>
                                <treeselect
                                    v-model="data.parent_service"
                                    :multiple="false"
                                    :clearOnSelect="true"
                                    :options="serviceOptions"
                                />
                                <span
                                    style="left: 0"
                                    class="error"
                                    v-if="errors.parent_service"
                                    >{{ errors.parent_service }}</span
                                >
                            </div>
                        </div>
                        <div class="col-xl-12 col-lg-12">
                            <div class="form-field form-field--textarea">
                                <label for="amount">Description</label>
                                <textarea
                                    id="terms"
                                    v-model="data.description"
                                    name="terms"
                                ></textarea>
                            </div>
                        </div>
                        <div class="col-xl-12 col-lg-12">
                            <div class="btn-wrap flex jus-c--center">
                                <button
                                    @click="handleAdd"
                                    type="button"
                                    class="btn"
                                >
                                    Add
                                </button>
                                <button
                                    @click="handleClose"
                                    type="button"
                                    class="btn"
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
    name: "addNewService",
    props: {
        onClose: {
            type: Function,
            required: true,
        },
        onAdd: {
            type: Function,
            required: true,
        },
        serviceOptions: {
            type: Array,
            required: true,
        },
    },
    components: {
        Treeselect,
    },
    data() {
        return {
            data: {
                name_of_service: "",
                parent_service: null,
                description: "",
            },
            errors: {
                name_of_service: null,
                parent_service: null,
                description: null,
            },
        };
    },

    methods: {
        handleClose(e) {
            this.onClose(e);
        },

        handleAdd() {
            this.validationFields();

            if (this.errors.name_of_service || this.errors.parent_service) {
                return;
            }

            this.onAdd({
                name: this.data.name_of_service,
                parent: this.data.parent_service,
                description: this.data.description,
            });
        },

        validationFields() {
            if (!this.data.name_of_service) {
                this.errors.name_of_service = "Required";
            }

            // if (!this.data.parent_service) {
            //     this.errors.parent_service = "Required";
            // }
        },
    },
};
</script>
